export default "/assets/images/the-big-sneeze-crop.png?bf8db748c226d5f4d24d56f7318a9dd4";